import React from "react";

export default function About() {
  return (
    <section id="about" className="max-w-5xl  dark:bg-slate-700 dark:text-white mx-auto py-16 px-6">
      <h2 className="text-3xl font-bold text-center text-blue-600 mb-8">About Me</h2>
      <p className="text-lg leading-relaxed text-gray-700 dark:text-gray-300">
        Welcome to the digital realm crafted by <span className="font-semibold">Daniel Mirigi</span>, 
        your go-to expert for comprehensive IT and blockchain solutions. I am a seasoned Full-Stack Web, 
        Blockchain, and Android Developer, dedicated to shaping cutting-edge projects, including dApps, 
        DEXs, and delivering top-notch Software as a Service (SaaS) solutions.
      </p>
    </section>
  );
}
